package com.partejar.app.core.ui.domain.gestante

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text

@Composable
fun GestationalAge(
    weeks: Int,
    days: Int,
    modifier: Modifier = Modifier
) {
    Text(
        text = "${weeks}s ${days}d",
        modifier = modifier,
        style = MaterialTheme.typography.titleLarge
    )
}
